import Image from 'next/legacy/image';
import React from 'react';

import whiteHeart from '../../public/images/white_heart.svg';
import yellowHeart from '../../public/images/yellow_heart.svg';
import goldHeart from '../../public/images/gold_heart.svg';

import whiteHeartFilled from '../../public/images/white_heart_filled.svg';
import yellowHeartFilled from '../../public/images/yelow_heart_filled.svg';
import goldHeartFilled from '../../public/images/gold_heart_filled.svg';

const Favorite: React.FC<{
  hover?: boolean;
  white?: boolean;
  fill?: boolean;
  width?: number;
  height?: number;
  desktopWidth?: number;
  desktopHeight?: number;
  darkGold?: boolean;
}> = ({
  hover,
  white,
  fill,
  width = 25,
  height = 23,
  desktopWidth,
  desktopHeight,
  darkGold,
}) => {
  let image = '';

  if (white) {
    if (fill) {
      if (hover) {
        image = yellowHeartFilled;
      } else {
        image = whiteHeartFilled;
      }
    } else {
      if (hover) {
        image = yellowHeart;
      } else {
        image = whiteHeart;
      }
    }
  } else {
    if (fill) {
      image = darkGold ? goldHeartFilled : yellowHeartFilled;
    } else {
      image = darkGold ? goldHeart : yellowHeart;
    }
  }

  if (desktopWidth === undefined && desktopHeight === undefined) {
    return <Image src={image} width={width} height={height} alt="add to favorites" />;
  }

  return (
    <>
      <span className="md:hidden inline-flex">
        <Image src={image} width={width} height={height} alt="add to favorites" />
      </span>
      <span className="hidden md:inline-flex">
        <Image
          src={image}
          width={desktopWidth ?? width}
          height={desktopHeight ?? height}
          alt="add to favorites"
        />
      </span>
    </>
  );
};

export default Favorite;
